export const MAX_CONTENT_TABS = 4;
